import { AgGrid } from "./ag_grid_hook"
import { mobileAccountsGridOptions } from "./mobile_accounts_grid_options.mjs"

const mobileViewport = window.matchMedia("(max-width: 639px)")
const touchViewport = window.matchMedia("(pointer: coarse)")

export const MobileAccountsAgGrid = {
  ...AgGrid,

  initGrid() {
    AgGrid.initGrid.call(this)

    this.desktopGridOptions = {
      rowHeight: this.gridOptions.rowHeight,
      defaultColDef: { ...this.gridOptions.defaultColDef },
      rowSelection: this.gridOptions.rowSelection,
      sideBar: this.gridOptions.sideBar,
      detailCellRendererParams: this.gridOptions.detailCellRendererParams,
    }
    this.updateViewportMode(mobileViewport.matches)

    this.onViewportChange = () =>
      this.updateViewportMode(mobileViewport.matches)
    mobileViewport.addEventListener("change", this.onViewportChange)
    touchViewport.addEventListener("change", this.onViewportChange)
  },

  updateViewportMode(mobile) {
    const gridOptions = mobileAccountsGridOptions(
      this.desktopGridOptions,
      mobile,
      touchViewport.matches,
    )

    this.api.updateGridOptions(gridOptions)
    // Resize open location grids as well as ones expanded after the breakpoint
    // changes. Let AG Grid position rows; CSS-only minimums overlap virtual rows.
    this.api.forEachDetailGridInfo(({ api }) => {
      api.setGridOption(
        "rowHeight",
        gridOptions.detailCellRendererParams.detailGridOptions.rowHeight,
      )
    })
    this.api.setSideBarVisible(!mobile && gridOptions.sideBar !== false)

    if (mobile) this.api.deselectAll()
  },

  destroyed() {
    mobileViewport.removeEventListener("change", this.onViewportChange)
    touchViewport.removeEventListener("change", this.onViewportChange)
    AgGrid.destroyed.call(this)
  },
}
